import React, {useEffect} from 'react';
import Icn from "../Icn";
import styled from "styled-components";
import useZibi from "../../zibi/UseZibi";

const ProductViewChangeStyled = styled.div`
  cursor: pointer;
`;

const CartViewAction = () => {
    const [cartViewTable, set_cartViewTable] = useZibi('cartViewTable');

    useEffect(() => {
        const isTable = localStorage.getItem("isTableView");
        set_cartViewTable(!!isTable);
    }, []);

    return (
        <ProductViewChangeStyled className="cart-view-action">
            {cartViewTable && (
                <Icn onClick={() => {
                    set_cartViewTable(false);
                    localStorage.removeItem("isTableView");
                }}>
                    gridViewIcon
                </Icn>
            )}
            {!cartViewTable && (
                <Icn onClick={() => {
                    set_cartViewTable(true);
                    localStorage.setItem("isTableView", "1");
                }}>
                    splitscreenIcon
                </Icn>
            )}
        </ProductViewChangeStyled>
    );
};

export default CartViewAction;